import React from "react";
import "./NotFound.css";

export default () =>
  <div className="NotFound">
    <h3>Die gesuchte Seite wurde nicht gefunden</h3>
  </div>;